import { makeStyles } from "@mui/styles";

export const useStylesCarousel = makeStyles({
  carouselRoot: {
    height: "739px",
  },
});
